import { INotification } from "shared/components/organisms/AppNotification/@types";
import { IMetadataFeedMetadata } from "shared/components/organisms/AppNotification/@types/feedTypes";
import { ILessonMetadata } from "shared/components/organisms/AppNotification/@types/lessonTypes";
import { IMetadataPostMetadata } from "shared/components/organisms/AppNotification/@types/postTypes";

import { captureException, captureMessage } from "@sentry/nextjs";

export const makeNotificationTextsDTO = (
  notification: INotification<ILessonMetadata | IMetadataPostMetadata>,
) => {
  const result = {
    currentUserPost: "",
    commenterAnswer: "",

    contentPhotoSrc: "",
    contentTitle: "",
    contentLocation: "",
    contentPhotoFallback: "",
  };

  try {
    const isLessonNotification = notification.type === "public_lesson_comment";
    const isPostNotification = notification.type === "public_post_comment";
    const isMentionNotification = notification.type === "mention";
    const isFeedNotification = notification.type === "feed_post_comment";

    if (isLessonNotification) {
      const data = notification as INotification<ILessonMetadata>;

      result.currentUserPost = `Comentou na sua publicação: "${data?.metadata?.replied_on?.content}"`;
      result.commenterAnswer = data?.metadata?.comment?.comment;
      result.contentPhotoSrc =
        data?.metadata?.location?.lesson?.lesson_thumbnail ??
        data?.metadata?.location?.group?.group_logo_horizontal;
      result.contentTitle = data?.metadata?.location?.lesson?.lesson_title;
      result.contentLocation = "Aula";
    }

    if (isPostNotification) {
      const data = notification as INotification<IMetadataPostMetadata>;

      result.currentUserPost = `Comentou na sua publicação: "${data?.metadata?.replied_on?.content}"`;
      result.commenterAnswer = data?.metadata?.comment?.comment;
      result.contentPhotoSrc =
        data?.metadata?.location?.group?.group_logo_horizontal;
      result.contentTitle = data?.metadata?.location?.group?.group_title;
      result.contentLocation = "Comunidade";
      result.contentPhotoFallback =
        data?.metadata?.location?.group?.group_primary_color;
    }

    if (isMentionNotification) {
      const data = notification as INotification<IMetadataPostMetadata>;
      const mentionWasMadeInLesson =
        !!data?.metadata?.location?.lesson?.lesson_slug;

      result.currentUserPost = `Mencionou você${
        !!data?.metadata?.replied_on?.content
          ? ` na publicação "${data?.metadata?.replied_on?.content}"`
          : ""
      }:`;
      result.commenterAnswer = data?.metadata?.comment?.comment;
      result.contentPhotoSrc =
        data?.metadata?.location?.lesson?.lesson_thumbnail ??
        data?.metadata?.location?.group?.group_logo_horizontal;
      result.contentTitle = mentionWasMadeInLesson
        ? data?.metadata?.location?.lesson?.lesson_title
        : data?.metadata?.location?.group?.group_title;
      result.contentLocation = mentionWasMadeInLesson ? "Aula" : "Comunidade";
      result.contentPhotoFallback =
        data?.metadata?.location?.group?.group_primary_color;
    }

    if (isFeedNotification) {
      const data = notification as INotification<IMetadataFeedMetadata>;

      result.currentUserPost = `Comentou na sua publicação: "${data?.metadata?.replied_on?.content}"`;
      result.commenterAnswer = data?.metadata?.comment?.comment;
      result.contentLocation = "Feed";
    }
  } catch (error) {
    console.log("Erro (makeNotificationTextsDTO): ", error);
    captureMessage("Erro (makeNotificationTextsDTO)");
    captureException(error);
  }

  return result;
};
